import apiClient from "./client";

const appendLinksToJson = (payload, links) => {
  if (Array.isArray(links) && links.length > 0) {
    payload.links = links;
  }
};

const appendLinksToFormData = (formData, links) => {
  links.forEach((link, index) => {
    formData.append(`links[${index}][title]`, link.title);
    formData.append(`links[${index}][url]`, link.url);
  });
};

const buildSponsorPayload = (payload, links = [], options = {}) => {
  const { methodOverride } = options;

  if (payload instanceof FormData) {
    appendLinksToFormData(payload, links);
    if (methodOverride) {
      payload.append("_method", methodOverride);
    }

    return {
      data: payload,
      config: {
        headers: { "Content-Type": "multipart/form-data" },
      },
      isFormData: true,
    };
  }

  const data = { ...payload };
  appendLinksToJson(data, links);

  return {
    data,
    isFormData: false,
  };
};

export const fetchSponsors = async () => {
  const response = await apiClient.get("/api/sponsors");
  return response.data.data ?? [];
};

export const createSponsor = async (payload, links = []) => {
  const request = buildSponsorPayload(payload, links);
  const response = await apiClient.post("/api/sponsors", request.data, request.config);

  return response.data.data ?? response.data;
};

export const updateSponsor = async (sponsorId, payload, links = []) => {
  const request = buildSponsorPayload(payload, links, {
    methodOverride: payload instanceof FormData ? "PATCH" : undefined,
  });
  const response = request.isFormData
    ? await apiClient.post(`/api/sponsors/${sponsorId}`, request.data, request.config)
    : await apiClient.patch(`/api/sponsors/${sponsorId}`, request.data, request.config);

  return response.data.data ?? response.data;
};

export const deleteSponsorById = async (sponsorId) => {
  await apiClient.delete(`/api/sponsors/${sponsorId}`);
};
